import React, { useState, useEffect, useRef } from 'react';
import styles from './ResearchUI.module.css';
import { useParams } from 'react-router';
import {
    Affix,
    Avatar,
    BackTop,
    Badge,
    Button,
    Card,
    Checkbox,
    Col,
    Collapse,
    DatePicker,
    Descriptions,
    Divider,
    Drawer,
    Dropdown,
    Form,
    Image,
    Input,
    Menu,
    message,
    Modal,
    Popconfirm,
    Radio,
    Row,
    Select,
    Space,
    Spin,
    Steps,
    Switch,
    Table,
    Tooltip,
    Typography,
    Upload,
} from 'antd';
import { researchUI } from '../../api';
import TextArea from 'antd/lib/input/TextArea';
import {
    PlusOutlined,
    MinusCircleOutlined,
    DownOutlined,
    CloseOutlined,
    UndoOutlined,
    CopyTwoTone,
    SwapLeftOutlined,
    HddTwoTone,
    SelectOutlined,
    LockOutlined,
    UnlockOutlined,
    UploadOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
    descProhabitedWordsList,
    currencyList,
    mlDefaultHiddenValues,
    fieldRules,
    DefaultHiddenQuestionList,
    FormFieldRules,
} from './HardValues';
import { ResearchUISteps, breachOnFinish } from './ResearchUIHelper';
import {
    AppCompletionStatus,
    ResearchUIEditAllowRoles,
    DefaultDateFormat,
    ResearchUIFunction,
    DefaultLogoImg,
    BreachDateFieldKeys,
    MessageString,
} from './ResearchUIConstants';
import { COMMON_CSS_PROPERTIES, SIZE, ANTD_SPACE, ANTD_COMMON_CSS, ANTD_TEXT } from '../Helper/Constant';
import * as apiUrl from '../../api/index';
import { safeHref } from '../../common/helper';

const { Option } = Select;
const { Step } = Steps;
const { Panel } = Collapse;
const { Text, Link, Paragraph } = Typography;

const fontSize = COMMON_CSS_PROPERTIES.FONT_SIZE;
const titleFontSize = COMMON_CSS_PROPERTIES.TITLE_FONT_SIZE;
const cardProp = {
    size: SIZE.SMALL,
    headStyle: {
        fontSize: titleFontSize,
        lineHeight: '8px',
        minHeight: '20px',
    },
};

let ID = null;
let USERNAME = null;
let ROLE = null;
let callcount = 1;
//Initial Data
let countryList = [];
let countryCodes = {};

let appData = {};
let category = {};
let categoryList = [];
let appInfoData = {};
let securityIndex = {};
let nsCciDB = {};
let mlProofData = {};
let mlHiddenList = [];

const RESTRICT = {
    allLocked: false,
    allAttributeLocked: false,
    category: false,
};
const completionStatus = Object.values(AppCompletionStatus);
const ALLOWEDROLE = ResearchUIEditAllowRoles;

const ResearchUI = (props) => {
    const stepMapping = Object.keys(ResearchUISteps);
    const { id } = useParams();
    ID = id;
    USERNAME = props.user.email.split('@')[0];
    ROLE = props.user.role;
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const [currentStep, setCurrentStep] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [gdprQuestions, setGdprQuestions] = useState([]);
    const [initialValue, setInitialValue] = useState({});
    const [valueChanged, setValueChanged] = useState({});
    const [viewOnly, setViewOnly] = useState(false);
    const [unSaved, setUnSaved] = useState(false);
    const [mlHidden, setMlHidden] = useState(false);
    const [appExist, setAppExist] = useState(true);

    const onlyOnce = useRef(false);

    useEffect(() => {
        (async () => {
            callcount++;
            const getInitData = async () => {
                const result = await researchUI({
                    function: ResearchUIFunction.GET_ALL_INIT_DATA,
                });
                categoryList = result.data.category.map((cat) => {
                    category[cat.category_id] = cat.category_name;
                    return { label: cat.category_name, value: cat.category_name };
                });

                countryList = result.data.country.map((i) => {
                    countryCodes[i.country_name] = i.country_code;
                    return { label: i.country_name, value: i.country_name };
                });
                countryList.unshift({ label: 'Select', value: 'select' });
            };

            const getQuestions = async () => {
                const result = await researchUI({
                    function: ResearchUIFunction.GET_ALL_QUESTIONS,
                    application_id: id,
                });
                setQuestions(result['data']['questions']);
                setGdprQuestions(result['data']['gdprQuestions']);
            };

            const mlProof = async () => {
                const result = await researchUI({
                    function: ResearchUIFunction.ML_PROOF_TEXT,
                    application_id: parseInt(ID),
                });
                result['data']['mlProofText'].map((i) => {
                    if (Object.keys(mlProofData).includes(i.question)) {
                        mlProofData[i.question].push(i);
                    } else {
                        mlProofData[i.question] = [i];
                    }
                });
            };

            const getAppInfoData = async () => {
                const result = await researchUI({
                    function: ResearchUIFunction.APPLICATION_INFO,
                    application_id: id,
                });

                if (result['data']['appInfo'] == null) {
                    setAppExist(false);
                    setLoading(false);
                } else {
                    await generateInitialValue(
                        'Applications',
                        ['ResearchData', 'AppLogo', 'GdprResearchData', 'ResearchMeta', 'ApplicationCategoryAssoc'],
                        'AppInfo',
                        result['data']['appInfo']
                    );

                    await generateInitialValue(
                        'AppSourceInfo',
                        ['AppContactInfo', 'ResearchAutomationAppCategory', 'ResearchAutomation'],
                        'SecurityIndex',
                        result['data']['securityIndex']
                    );

                    await generateApplicationInfo(result['data']['appInfo']);
                    appInfoData = result['data']['appInfo'];
                    securityIndex = result['data']['securityIndex'];
                    nsCciDB = result['data']['nsCciDB'];

                    if (nsCciDB?.restrict_data) {
                        if (nsCciDB?.restrict_data?.restrict.includes('all')) {
                            RESTRICT.allLocked = true;
                        }
                        if (nsCciDB?.restrict_data?.restrict.includes('all_attributes')) {
                            RESTRICT.allAttributeLocked = true;
                        }
                        if (nsCciDB?.restrict_data?.restrict.includes('category')) {
                            RESTRICT.category = true;
                        }
                    }
                    await setInitialValueManual();
                    setLoading(false);
                    console.log(initialValue);
                    if (appInfoData?.ResearchData?.createdBy != USERNAME && !ALLOWEDROLE.includes(props.user.role)) {
                        setMlHidden(false);
                        setViewOnly(true);
                    }
                    //Ml Hidden
                    securityIndex.ResearchAutomationResults.map((i) => {
                        if (i.db_match == 1) {
                            mlHiddenList.push(i.attribute);
                        }
                        if (i.db_match == 0) {
                            if (Object.keys(mlDefaultHiddenValues).includes(i.attribute)) {
                                if (
                                    i.ml_result == mlDefaultHiddenValues[i.attribute] &&
                                    (i.ml_result == appInfoData?.ResearchData[i.attribute] ||
                                        i.ml_result == appInfoData?.GdprResearchData[i.attribute])
                                ) {
                                    mlHiddenList.push(i.attribute);
                                }
                            }
                        }
                    });
                }
            };
            await getInitData();
            getAppInfoData();
            mlProof();
            getQuestions();
        })();
    }, [id]);

    const setInitialValueManual = () => {
        //ML Category
        initialValue['SecurityIndex.ResearchAutomationAppCategory.selected_category'] =
            securityIndex?.ResearchAutomationAppCategory?.selected_category == null
                ? category[appInfoData?.ApplicationCategoryAssoc?.category_id]
                : securityIndex?.ResearchAutomationAppCategory?.selected_category;
        initialValue['restrict'] = nsCciDB?.restrict_data?.restrict;
        initialValue['restrictComment'] = nsCciDB?.restrict_data?.comments;
        setInitialValue(initialValue);
    };

    const generateInitialValue = (refTableName, includeTables, dbName, result) => {
        const dateKeys = ['research_meta'];
        Object.entries(result).map(([key, value]) => {
            if (includeTables.includes(key)) {
                if (value) {
                    Object.entries(value).map(([inKey, inValue]) => {
                        if (dateKeys.includes(inKey)) {
                            inValue = inValue.map((item) => {
                                BreachDateFieldKeys.forEach((dateKey) => {
                                    item[dateKey] = moment(item[dateKey]);
                                });
                                return item;
                            });
                            inValue = inValue.filter((item) => Object.keys(item).length != 0);
                        }
                        initialValue[dbName + '.' + key + '.' + inKey] = inValue;
                    });
                }
            } else {
                initialValue[dbName + '.' + refTableName + '.' + key] = value;
            }
        });
        setInitialValue(initialValue);
    };

    const generateApplicationInfo = (data) => {
        appData = {
            appLogo: {
                title: 'App Logo',
                value: data?.AppLogo?.appLogoURL,
                color: 'black',
                tagType: 'Avatar',
            },
            appName: {
                title: 'App Name',
                value: data?.current_name,
                color: 'black',
                tagType: 'Tag',
            },
            url: {
                title: 'Url',
                value: data?.AppUrl?.url,
                color: 'black',
                tagType: 'Tag',
                link: true,
            },
            category: {
                title: 'Category',
                value: category[data?.ApplicationCategoryAssoc?.category_id],
                color: 'black',
                tagType: 'Tag',
            },
            status: {
                title: 'Status',
                value: data?.ResearchData?.completionStatus,
                color: 'black',
                tagType: 'Tag',
            },
            priority: {
                title: 'Priority',
                value: data?.ResearchData?.customtag?.includes('custom_p1') ? 'P1' : null,
                color: 'black',
                tagType: null,
            },
        };
    };

    const onChangeStep = (currentStep) => {
        setCurrentStep(currentStep);
        window.scrollTo(0, 0);
        if (Object.keys(valueChanged).includes(stepMapping[currentStep])) {
            if (Object.keys(valueChanged[stepMapping[currentStep]]).length > 0) {
                setUnSaved(true);
            } else setUnSaved(false);
        } else setUnSaved(false);
    };

    const onFinish = async (values) => {
        console.log('onFinish : ', values);
        if (stepMapping[currentStep] == ResearchUISteps.basicInfo.step_id) {
            if (values?.['SecurityIndex.ResearchAutomationAppCategory.selected_category']) {
                values['SecurityIndex.ResearchAutomationAppCategory.primary_category_match'] =
                    values['SecurityIndex.ResearchAutomationAppCategory.selected_category'] ==
                    securityIndex.ResearchAutomationAppCategory.primary_category
                        ? 1
                        : -1;
                values['SecurityIndex.ResearchAutomationAppCategory.secondary_category_match'] =
                    values['SecurityIndex.ResearchAutomationAppCategory.selected_category'] ==
                    securityIndex.ResearchAutomationAppCategory.secondary_category
                        ? 1
                        : -1;
            }

            values['AppInfo.ResearchData.TOS_NA'] = 0;
            if (values?.['AppInfo.ResearchData.TOS'] == null || values?.['AppInfo.ResearchData.TOS'] == '') {
                values['AppInfo.ResearchData.TOS_NA'] = 1;
            }

            values['AppInfo.ResearchData.IsLoginPageURL'] = 1;
            if (values?.['AppInfo.ResearchData.LoginPageURL'] == null || values?.['AppInfo.ResearchData.LoginPageURL'] == '') {
                values['AppInfo.ResearchData.IsLoginPageURL'] = 0;
            }

            if (Object.keys(countryCodes).includes(values['AppInfo.ResearchData.countries'])) {
                values['AppInfo.ResearchData.country_code'] = countryCodes[values['AppInfo.ResearchData.countries']];
            }
            if (appInfoData?.ResearchData?.completionStatus.includes(AppCompletionStatus.APP_ALL_COMPLETE)) {
                let error = [];
                if (values['AppInfo.AppLogo.appLogoURL'] == '') error.push('Logo Link');
                if (values['AppInfo.AppLogo.fav_icon_logo_url'] == '') error.push('Fav Icon');
                if (values['AppInfo.Applications.description'] == '') error.push('Description');
                if (values['AppInfo.ResearchData.city_id'] == '') error.push('City Name');
                if (values['AppInfo.ResearchData.appcompanyname'] == '') error.push('Company Name');
                if (error.length > 0) {
                    error.unshift('Below Attributes can not be empty while status is App All Complete.');
                    message.error(
                        <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                            {error.map((i) => (
                                <Text key={i}>
                                    <SwapLeftOutlined />
                                    {i}
                                </Text>
                            ))}
                        </Space>,
                        5
                    );
                    return false;
                }
            }
        }
        if (stepMapping[currentStep] === ResearchUISteps.disasterRecovery.step_id) {
            if (values?.['AppInfo.ResearchMeta.research_meta']) {
                values['AppInfo.ResearchMeta.research_meta'] = breachOnFinish(values['AppInfo.ResearchMeta.research_meta']);
            }
        }

        Object.keys(values).map((k) => {
            if (values[k] == null || values[k] == undefined) delete values[k];
        });
        const submitData = async () => {
            const result = await researchUI({
                function: ResearchUIFunction.SUBMIT_APP_DATA,
                data: values,
                application_id: id,
                step: stepMapping[currentStep],
                user: props.user.email.split('@')[0],
            });
            if (result?.success == 1) {
                message.success('Data Saved');
                valueChanged[stepMapping[currentStep]] = {};
                setValueChanged(valueChanged);
                setUnSaved(false);
            } else {
                message.error(result?.msg);
            }
        };
        submitData();
        if (stepMapping[currentStep] === ResearchUISteps.disasterRecovery.step_id) {
            if (values?.['AppInfo.ResearchMeta.research_meta']) {
                changeBreachDateFormat();
            }
        }
    };

    const changeBreachDateFormat = () => {
        let breachData = form.getFieldValue('AppInfo.ResearchMeta.research_meta');
        breachData = breachData?.map((i) => {
            if (i?.date) {
                i.date = moment(i?.date, DefaultDateFormat);
            }
            if (i?.netskope_publish_date) {
                i.netskope_publish_date = moment(i?.netskope_publish_date, DefaultDateFormat);
            }
            if (i?.public_disclosure_date) {
                i.public_disclosure_date = moment(i?.public_disclosure_date, DefaultDateFormat);
            }
            return i;
        });
        form.setFieldsValue({
            'AppInfo.ResearchMeta.research_meta': breachData,
        });
    };

    const onFormValueChange = async (changedValues, allValues) => {
        if (!Object.keys(valueChanged).includes(stepMapping[currentStep])) valueChanged[stepMapping[currentStep]] = {};
        valueChanged[stepMapping[currentStep]][Object.keys(changedValues)[0]] = Object.values(changedValues)[0];
        setUnSaved(true);
        let attrBasedRule = {
            FS: {
                attr: 'AppInfo.ResearchData.FS',
                onValue: ['No', 'NA'],
                basedAttr: 'AppInfo.ResearchData.FSsize',
                basedValue: 'No',
            },
            datapertenancy: {
                attr: 'AppInfo.ResearchData.datapertenancy',
                onValue: ['No', 'NA'],
                basedAttr: 'AppInfo.ResearchData.EncryptTenantKey',
                basedValue: 'No',
            },
            dataClassification: {
                attr: 'AppInfo.ResearchData.dataClassification',
                onValue: ['No', 'NA'],
                basedAttr: 'AppInfo.ResearchData.classificationCapabilities',
                basedValue: 'No',
            },
        };
        let attrSet = {};
        Object.values(attrBasedRule).map((i) => {
            if (i.onValue.includes(form.getFieldValue(i.attr))) attrSet[i.basedAttr] = i.basedValue;
        });
        form.setFieldsValue(attrSet);
    };

    const onFinishFailed = () => {
        message.info(MessageString.FINISH_FAILED_MSG);
    };

    return (
        <div style={{ display: COMMON_CSS_PROPERTIES.DISPLAY_BLOCK }} key={'div_research_ui_main'}>
            <BackTop />
            {loading ? (
                <Row justify={ANTD_COMMON_CSS.JUSTIFY_CENTER} gutter={24}>
                    <Col span={1}>
                        <Spin tip="Loading..."></Spin>
                    </Col>
                </Row>
            ) : (
                <div key={'div_research_ui'}>
                    {!appExist ? (
                        <Row justify={ANTD_COMMON_CSS.JUSTIFY_CENTER} gutter={24}>
                            <Col>
                                <Text>App Not Found</Text>
                            </Col>
                        </Row>
                    ) : (
                        <Form
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            initialValues={initialValue}
                            form={form}
                            onValuesChange={onFormValueChange}
                            scrollToFirstError
                            size={SIZE.SMALL}
                        >
                            <Row gutter={24} justify={ANTD_COMMON_CSS.JUSTIFY_CENTER}>
                                <Col span={23}>
                                    <Affix offsetTop={0} style={{ backgroundColor: 'white' }}>
                                        <Space key={'app_info_steps'} direction={ANTD_SPACE.DIRECTION_VERTICAL} size={0}>
                                            <ApplicationInfo
                                                key={'application_info_component'}
                                                appData={appData}
                                                appInfoData={appInfoData}
                                                form={form}
                                                viewOnly={viewOnly}
                                                unSaved={unSaved}
                                                setMlHidden={setMlHidden}
                                                mlHidden={mlHidden}
                                                valueChanged={valueChanged}
                                            />
                                            <Steps
                                                size={SIZE.SMALL}
                                                current={currentStep}
                                                onChange={onChangeStep}
                                                style={{
                                                    marginBottom: '5px',
                                                    backgroundColor: 'white',
                                                }}
                                            >
                                                {Object.values(ResearchUISteps).map(function (item, index) {
                                                    return (
                                                        <Step
                                                            key={'step_' + index}
                                                            title={
                                                                <Tooltip title={item.title}>
                                                                    <Text style={{ fontSize: '12px' }}>{item.title}</Text>
                                                                </Tooltip>
                                                            }
                                                        ></Step>
                                                    );
                                                })}
                                            </Steps>
                                        </Space>
                                    </Affix>
                                </Col>
                            </Row>
                            <Row gutter={24} justify={ANTD_COMMON_CSS.JUSTIFY_CENTER}>
                                <Col span={23}>
                                    {Object.keys(ResearchUISteps).map(function (quesCat) {
                                        if (quesCat != stepMapping[currentStep]) return '';
                                        if (quesCat == 'submission') return '';
                                        if (quesCat == 'basicInfo') {
                                            return (
                                                <BasicInfo
                                                    key={'basic_info'}
                                                    appInfoData={appInfoData}
                                                    form={form}
                                                    user={props.user}
                                                    viewOnly={viewOnly}
                                                    onlyOnce={onlyOnce}
                                                />
                                            );
                                        }
                                        return (
                                            <Row key={'ques_cat_' + quesCat}>
                                                <Col span={24}>
                                                    {ResearchUISteps[quesCat].category.map(function (item) {
                                                        if (item == 'gdpr') {
                                                            return (
                                                                <GDPR
                                                                    gdprQuestions={gdprQuestions}
                                                                    securityIndex={securityIndex}
                                                                    form={form}
                                                                    viewOnly={viewOnly}
                                                                    mlHidden={mlHidden}
                                                                />
                                                            );
                                                        }

                                                        const catQues = questions.filter((q) => q.category_name == item)[0];
                                                        if (!catQues) return '';
                                                        return (
                                                            <Row key={'ques_' + item}>
                                                                <Col span={24}>
                                                                    <Divider orientation="left">{catQues.category_text}</Divider>
                                                                    {catQues.AppIndexQuestions.map((ques, index) => {
                                                                        if (
                                                                            DefaultHiddenQuestionList.includes(ques.question_col_name) ||
                                                                            !appInfoData
                                                                        ) {
                                                                            return '';
                                                                        }

                                                                        if (ques.question_col_name == 'recent_breach') {
                                                                            return (
                                                                                <Breach
                                                                                    key={'breach_div'}
                                                                                    form={form}
                                                                                    viewOnly={viewOnly}
                                                                                />
                                                                            );
                                                                        }

                                                                        return (
                                                                            <div key={'ques_' + item + '_' + index}>
                                                                                {mlHiddenList.includes(ques.question_col_name) &&
                                                                                mlHidden == false ? null : (
                                                                                    <Card
                                                                                        size={SIZE.SMALL}
                                                                                        title={ques.question_text}
                                                                                        style={{ marginBottom: '5px' }}
                                                                                    >
                                                                                        <QuestionRow
                                                                                            ques={ques}
                                                                                            form={form}
                                                                                            viewOnly={viewOnly}
                                                                                        />
                                                                                    </Card>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </Col>
                                                            </Row>
                                                        );
                                                    })}
                                                </Col>
                                            </Row>
                                        );
                                    })}
                                </Col>
                            </Row>
                        </Form>
                    )}
                </div>
            )}
        </div>
    );
};

const QuestionRow = (props) => {
    const ques = props.ques;
    const form = props.form;
    const viewOnly = props.viewOnly;

    let allLocked = false;
    let iniLocked = false;
    if (nsCciDB?.restrict_data) {
        if (RESTRICT.allLocked || RESTRICT.allAttributeLocked) {
            allLocked = true;
        }
        if (nsCciDB?.restrict_data?.restrict_attributes.includes(ques.question_col_name) || allLocked) {
            iniLocked = true;
        }
    }

    const [isLocked, setIsLocked] = useState(iniLocked);

    return (
        <Row>
            <Col span={8}>
                <ChoiceValue
                    form={form}
                    appInfoData={appInfoData}
                    securityIndex={securityIndex}
                    ques={ques}
                    viewOnly={viewOnly || isLocked}
                />
            </Col>
            <Col span={16}>
                <Space direction={ANTD_SPACE.DIRECTION_VERTICAL} style={{ width: '100%' }}>
                    <TextAreaField
                        key={ques.question_col_name}
                        form={form}
                        appInfoData={appInfoData}
                        securityIndex={securityIndex}
                        ques={ques}
                        viewOnly={viewOnly || isLocked}
                        isLocked={isLocked}
                        setIsLocked={setIsLocked}
                        allLocked={allLocked}
                    />
                    <MlValidate
                        ques={ques}
                        securityIndex={securityIndex}
                        form={form}
                        quesType={'appInfo'}
                        quesFieldText={
                            ques.src_info_col_name == ''
                                ? 'SecurityIndex.AppSourceInfo.' + ques.question_col_name + 'Text'
                                : 'SecurityIndex.AppSourceInfo.' + ques.src_info_col_name
                        }
                        viewOnly={viewOnly || isLocked}
                    />
                </Space>
            </Col>
        </Row>
    );
};

const ChoiceValue = (props) => {
    const form = props.form;
    const ques = props.ques;
    const appInfoResearchDataName = 'AppInfo.ResearchData.';

    const onMultiValueCheckBoxChange = (changedValue, formAttributes) => {
        if (changedValue.includes('NS')) {
            let v = {};
            v[formAttributes] = ['NS'];
            form.setFieldsValue(v);
            return;
        }
        if (changedValue.includes('NA')) {
            let v = {};
            v[formAttributes] = ['NA'];
            form.setFieldsValue(v);
        }
    };

    return (
        <div key={'choice_values'}>
            <Space size={SIZE.MIDDLE}>
                {ques.multi_valued && !ques.is_single_select ? (
                    <Form.Item name={appInfoResearchDataName + ques.question_col_name} size={SIZE.SMALL}>
                        <Checkbox.Group
                            style={{ lineHeight: '0.5' }}
                            onChange={(e) => onMultiValueCheckBoxChange(e, appInfoResearchDataName + ques.question_col_name)}
                            disabled={props.viewOnly}
                        >
                            <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                {ques.AppIndexQuestionChoices.map((choice) => {
                                    return (
                                        <Checkbox
                                            key={'choice_value_checkbox_' + choice.choice_value}
                                            value={choice.choice_value}
                                            style={{ fontSize: fontSize }}
                                        >
                                            {choice.choice_text == '' ? choice.choice_value : choice.choice_text}
                                        </Checkbox>
                                    );
                                })}
                            </Space>
                        </Checkbox.Group>
                    </Form.Item>
                ) : (
                    <Form.Item name={appInfoResearchDataName + ques.question_col_name}>
                        <Radio.Group style={{ lineHeight: '0.7' }} disabled={props.viewOnly}>
                            <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                {ques.AppIndexQuestionChoices.map((choice) => {
                                    return (
                                        <Radio
                                            key={'choice_value_radio_' + choice.choice_value}
                                            value={choice.choice_value}
                                            style={{ fontSize: fontSize }}
                                            disabled={!ALLOWEDROLE.includes(ROLE) && choice.choice_value == 'Not Applicable' ? true : false}
                                        >
                                            {choice.choice_text == '' ? choice.choice_value : choice.choice_text}
                                        </Radio>
                                    );
                                })}
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                )}
            </Space>
        </div>
    );
};

const TextAreaField = (props) => {
    const ques = props.ques;
    const form = props.form;
    const securityIndexAppSourceInfo = 'SecurityIndex.AppSourceInfo.';

    const [locked, setLocked] = useState(props.isLocked);

    const resetField = (question) => {
        form.resetFields(['AppInfo.ResearchData.' + question]);
    };

    const setRestrictLock = async () => {
        const result = await researchUI({
            function: ResearchUIFunction.SET_RESTRICT_DATA,
            application_id: ID,
            attribute: ques.question_col_name,
            locked: !locked,
        });
        if (result.success === 1) {
            message.success('Successfully Saved');
            setLocked(!locked);
            props.setIsLocked(!locked);
        } else {
            message.error(result.msg);
        }
    };

    const onClickLock = () => {
        if (!props.allLocked) {
            setRestrictLock();
        }
    };
    return (
        <>
            <Row>
                <Col span={1}>
                    <Button onClick={() => resetField(ques.question_col_name)}>
                        <UndoOutlined />
                    </Button>
                    {ALLOWEDROLE.includes(ROLE) ? (
                        <Button onClick={onClickLock}>
                            {locked ? <LockOutlined style={{ color: 'red' }} /> : <UnlockOutlined style={{ color: 'green' }} />}
                        </Button>
                    ) : null}
                </Col>
                <Col span={23}>
                    <Form.Item
                        name={
                            ques.src_info_col_name == ''
                                ? securityIndexAppSourceInfo + ques.question_col_name + 'Text'
                                : securityIndexAppSourceInfo + ques.src_info_col_name
                        }
                    >
                        <Input.TextArea showCount autoSize={true} disabled={props.viewOnly}></Input.TextArea>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

const MlValidate = (props) => {
    const [modalLoading, setModalLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selQues, setSelQues] = useState('');
    const [okBtnCall, setOkBtnCall] = useState(false);

    const ques = props.ques;
    const form = props.form;
    const securityIndex = props.securityIndex;
    const mlAttributeResult = {};

    let quesFieldText = props.quesFieldText;

    securityIndex.ResearchAutomationResults.map((result) => {
        mlAttributeResult[result.attribute] = result;
    });
    const onMlValidatebtnClick = (rowId, question, mlResult, multiValued) => {
        let match = 1;
        let quesField = props.quesType == 'gdpr' ? 'AppInfo.GdprResearchData.' + question : 'AppInfo.ResearchData.' + question;
        if (multiValued == 0) {
            if (form.getFieldValue(quesField) != mlResult) match = -1;
        } else if (multiValued == 1) {
            let userResult = form.getFieldValue(quesField);
            let mlResultSp = mlResult
                .split(',')
                .map((i) => i.trim())
                .filter((i) => (i != '' ? true : false));
            mlResultSp.map((i) => {
                if (!userResult.includes(i)) {
                    match = -1;
                }
            });
        }
        const mlValidate = async () => {
            const result = await researchUI({
                function: ResearchUIFunction.ML_VALIDATE,
                id: rowId,
                attribute_match: match,
                db_match: multiValued == 1 ? 0 : 1,
            });
            message.success(result.msg);
        };
        mlValidate();
    };

    const closeModal = () => {
        setModalTitle('');
        setShowModal(false);
    };

    return (
        <>
            {mlAttributeResult[ques.question_col_name] ? (
                <>
                    <Space size={SIZE.SMALL}>
                        <Text style={{ fontSize: fontSize }}>Ml Result: {mlAttributeResult[ques.question_col_name].ml_result}</Text>

                        {mlAttributeResult[ques.question_col_name].db_match != 1 ? (
                            <>
                                {mlAttributeResult[ques.question_col_name].attribute_match == 0 ? (
                                    <Popconfirm
                                        placement="top"
                                        title="Are You Sure to Change ML Result"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={() =>
                                            onMlValidatebtnClick(
                                                mlAttributeResult[ques.question_col_name].id,
                                                ques.question_col_name,
                                                mlAttributeResult[ques.question_col_name].ml_result,
                                                ques.multi_valued
                                            )
                                        }
                                    >
                                        <Button size={SIZE.SMALL} type="primary" disabled={props.viewOnly}>
                                            ML Validate
                                        </Button>
                                    </Popconfirm>
                                ) : null}
                            </>
                        ) : null}
                        {Object.keys(mlProofData).includes(ques.question_col_name) ? (
                            <Button
                                size={SIZE.SMALL}
                                type="primary"
                                onClick={() => {
                                    setModalTitle(ques.question_text);
                                    setSelQues(ques.question_col_name);
                                    setShowModal(true);
                                }}
                                disabled={props.viewOnly && ROLE != 'researcher'}
                            >
                                ML Proof
                            </Button>
                        ) : null}
                    </Space>
                </>
            ) : null}
            {Object.keys(mlProofData).includes(ques.question_col_name) ? (
                <Modal
                    title={modalLoading ? <Spin size={SIZE.SMALL} /> : <Text>{modalTitle}</Text>}
                    visible={showModal}
                    confirmLoading={modalLoading}
                    okText={'Save'}
                    onCancel={closeModal}
                    onOk={() => setOkBtnCall(true)}
                    width={'70%'}
                >
                    <MLProofModalBody
                        form={form}
                        ques={ques}
                        question={selQues}
                        okBtn={okBtnCall}
                        setOkBtn={setOkBtnCall}
                        setModalVis={closeModal}
                        quesFieldText={quesFieldText}
                        viewOnly={props.viewOnly}
                    />
                </Modal>
            ) : null}
        </>
    );
};

const MLProofModalBody = (props) => {
    const column = [
        {
            title: 'Link',
            dataIndex: 'links',
            key: 'links',
            render: (text, record) => (
                <>
                    {safeHref(text) ? (
                        <a href={safeHref(text)} target="_blank">
                            {text}
                        </a>
                    ) : (
                        <span>{text}</span>
                    )}
                    <br></br>
                    <span style={{ fontSize: 10, color: 'grey', fontWeight: 500 }}>{record.Date}</span>
                </>
            ),
        },
        {
            title: 'Proof Text',
            dataIndex: 'proof_text',
            key: 'proof_text',
        },
    ];

    const [proofData, setProofData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [tableColumn, setTableColumn] = useState(column);

    useEffect(() => {
        setLoading(true);
        if (props.ques.multi_valued == 1) {
            setTableColumn([
                {
                    title: 'Link',
                    dataIndex: 'links',
                    key: 'links',
                    render: (text, record) => (
                        <>
                            {safeHref(text) ? (
                                <a href={safeHref(text)} target="_blank">
                                    {text}
                                </a>
                            ) : (
                                <span>{text}</span>
                            )}
                            <br></br>
                            <span style={{ fontSize: 10, color: 'grey', fontWeight: 500 }}>{record.Date}</span>
                        </>
                    ),
                },
                {
                    title: 'Search Key',
                    dataIndex: 'search_key',
                    key: 'search_key',
                },
                {
                    title: 'Proof Text',
                    dataIndex: 'proof_text',
                    key: 'proof_text',
                },
            ]);
        }
        setProofData(mlProofData[props.question]);
        setSelectedRowKeys(mlProofData[props.question].filter((i) => (i.is_useful == 1 ? true : false)).map((i) => i.id));
        setLoading(false);
    }, [props.question]);

    const onChangeProof = (selectedRowKeysTable, selectedRows) => {
        setSelectedRowKeys(selectedRowKeysTable);
    };

    useEffect(() => {
        if (props.okBtn == true) {
            let unselected = proofData
                .filter((i) => {
                    if (selectedRowKeys.includes(i.id)) return false;
                    return true;
                })
                .map((i) => i.id);
            const mlProofUpdate = async () => {
                const result = await researchUI({
                    function: ResearchUIFunction.ML_PROOF_UPDATE,
                    application_id: parseInt(ID),
                    selected: selectedRowKeys,
                    unselected: unselected,
                });
                message.info(result.msg);
                let fields = {};
                let proof = [];
                let oldFieldValue = props.form.getFieldValue(props.quesFieldText);
                if (!oldFieldValue) oldFieldValue = '';
                proof.push(oldFieldValue);
                selectedRowKeys.map((i) => {
                    mlProofData[props.question].map((ml) => {
                        if (ml.id == i) proof.push(ml.links, ml.proof_text);
                    });
                });
                fields[props.quesFieldText] = proof.join('\n\n');
                props.form.setFieldsValue(fields);
                props.setModalVis();
            };
            mlProofUpdate();
            props.setOkBtn(false);
        }
    }, [props.okBtn]);

    return (
        <>
            <Table
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys,
                    onChange: onChangeProof,
                    getCheckboxProps: (record) => ({ disabled: props.viewOnly }),
                }}
                rowKey="id"
                size={SIZE.SMALL}
                bordered
                scroll={{ x: 800, y: 400 }}
                style={{ margin: '2px', fontSize: fontSize }}
                loading={loading}
                columns={tableColumn}
                dataSource={proofData}
                pagination={false}
            ></Table>
        </>
    );
};

const Breach = (props) => {
    const viewOnly = props.viewOnly;
    useEffect(() => {
        let breachData = props.form.getFieldValue('AppInfo.ResearchMeta.research_meta');
        breachData = breachData?.map((i) => {
            if (i?.date) {
                i.date = moment(i?.date, DefaultDateFormat);
            }
            if (i?.netskope_publish_date) {
                i.netskope_publish_date = moment(i?.netskope_publish_date, DefaultDateFormat);
            }
            if (i?.public_disclosure_date) {
                i.public_disclosure_date = moment(i?.public_disclosure_date, DefaultDateFormat);
            }
            return i;
        });
        props.form.setFieldsValue({
            'AppInfo.ResearchMeta.research_meta': breachData,
        });
    }, [props]);

    let allLocked = false;
    let iniLocked = false;
    if (nsCciDB?.restrict_data) {
        if (RESTRICT.allLocked || RESTRICT.allAttributeLocked) {
            allLocked = true;
        }
        if (nsCciDB?.restrict_data?.restrict_attributes.includes('recent_breach') || allLocked) {
            iniLocked = true;
        }
    }

    const [locked, setLocked] = useState(iniLocked);

    const setRestrictLock = async () => {
        const result = await researchUI({
            function: ResearchUIFunction.SET_RESTRICT_DATA,
            application_id: ID,
            attribute: 'recent_breach',
            locked: !locked,
        });
        if (result.success === 1) {
            message.success('Successfully Saved');
            setLocked(!locked);
        } else {
            message.error(result.msg);
        }
    };

    const onClickLock = () => {
        if (!allLocked) {
            setRestrictLock();
        }
    };

    const disabledDate = (current, index) => {
        let breachData = props.form.getFieldValue('AppInfo.ResearchMeta.research_meta');
        if (!breachData[index]) return false;
        return current && current < breachData[index].date;
    };

    return (
        <Card size={SIZE.SMALL} title="Has this application been recently breached (in the past year)?" key={'breach'}>
            <Row>
                <Col span={5}>
                    <Form.Item name="AppInfo.ResearchData.recent_breach">
                        <Radio.Group disabled={viewOnly || locked}>
                            <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                                <Radio value="NA">Under Research</Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                </Col>
                <Col span={1}>
                    {ALLOWEDROLE.includes(ROLE) ? (
                        <Button onClick={onClickLock}>
                            {locked ? <LockOutlined style={{ color: 'red' }} /> : <UnlockOutlined style={{ color: 'green' }} />}
                        </Button>
                    ) : null}
                </Col>
                <Col span={18}>
                    <Form.List name="AppInfo.ResearchMeta.research_meta" key={'breach_form'}>
                        {(breachFields, { add, remove }) => (
                            <>
                                {breachFields.map((field, index) => (
                                    <div key={'div_breach_' + index}>
                                        <Space
                                            style={{ display: 'flex', marginBottom: 6 }}
                                            align={ANTD_SPACE.ALIGN_BASELINE}
                                            key={'space_breach' + index}
                                        >
                                            <Space
                                                size={SIZE.SMALL}
                                                direction={ANTD_SPACE.DIRECTION_VERTICAL}
                                                key={'space_breach_outer' + index}
                                            >
                                                <Space align={ANTD_SPACE.ALIGN_CENTER} key={'space_breach_inner' + index}>
                                                    <Form.Item
                                                        {...field}
                                                        name={[field.name, 'name']}
                                                        fieldKey={[field.key, 'name']}
                                                        style={{ marginBottom: '8px' }}
                                                        rules={FormFieldRules.BREACH.breachName}
                                                        key={'breach_form_' + index + '_name'}
                                                    >
                                                        <Input placeholder="Breach Name" disabled={viewOnly || locked}></Input>
                                                    </Form.Item>
                                                    <Form.Item
                                                        {...field}
                                                        name={[field.name, 'date']}
                                                        fieldKey={[field.key, 'date']}
                                                        style={{ marginBottom: '8px' }}
                                                        rules={FormFieldRules.BREACH.default}
                                                        key={'breach_form_' + index + '_date'}
                                                    >
                                                        <DatePicker picker="date" disabled={viewOnly || locked} />
                                                    </Form.Item>
                                                    <Form.Item
                                                        {...field}
                                                        name={[field.name, 'recent']}
                                                        fieldKey={[field.key, 'recent']}
                                                        style={{ marginBottom: '8px' }}
                                                        rules={FormFieldRules.BREACH.default}
                                                        key={'breach_form_' + index + '_recent'}
                                                    >
                                                        <Radio.Group disabled={viewOnly || locked}>
                                                            <Space direction={ANTD_SPACE.DIRECTION_HORIZONTAL}>
                                                                <Radio value="Yes">Yes</Radio>
                                                                <Radio value="No">No</Radio>
                                                            </Space>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Space>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'public_disclosure_date']}
                                                    fieldKey={[field.key, 'public_disclosure_date']}
                                                    style={{ marginBottom: '8px' }}
                                                    label={'Public Disclosure Date'}
                                                    rules={FormFieldRules.BREACH.default}
                                                    key={'breach_form_' + index + 'public_disclosure_date'}
                                                >
                                                    <DatePicker
                                                        className="ns-width-full"
                                                        picker="date"
                                                        disabled={viewOnly || locked}
                                                        disabledDate={(current) => disabledDate(current, index)}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'netskope_publish_date']}
                                                    fieldKey={[field.key, 'publish_date']}
                                                    style={{ marginBottom: '8px' }}
                                                    label={'Netskope Publish Date'}
                                                    rules={FormFieldRules.BREACH.default}
                                                    key={'breach_form_' + index + 'netskope_publish_date'}
                                                >
                                                    <DatePicker
                                                        className="ns-width-full"
                                                        picker="date"
                                                        disabled={viewOnly || locked}
                                                        disabledDate={(current) => disabledDate(current, index)}
                                                    />
                                                </Form.Item>
                                            </Space>
                                            <div
                                                key={'div_breach_outer' + index}
                                                style={{
                                                    border: '2px solid black',
                                                    padding: '5px',
                                                    minWidth: '380px',
                                                }}
                                            >
                                                <Form.List name={[field.name, 'media_links']} rules={FormFieldRules.BREACH.source}>
                                                    {(breachSourceField, { add, remove }, { errors }) => (
                                                        <>
                                                            {breachSourceField.map((fieldInner, sourceIndex) => (
                                                                <Space
                                                                    align={ANTD_SPACE.ALIGN_START}
                                                                    key={'space_source_' + index + '_' + sourceIndex}
                                                                >
                                                                    <Form.Item
                                                                        {...fieldInner}
                                                                        name={[fieldInner.name, 'source']}
                                                                        fieldKey={[fieldInner.key, 'source']}
                                                                        rules={FormFieldRules.BREACH.sourceField}
                                                                        key={'source_form_' + index + '_' + sourceIndex + '_source'}
                                                                    >
                                                                        <TextArea
                                                                            placeholder="Source Name"
                                                                            disabled={viewOnly || locked}
                                                                        ></TextArea>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...fieldInner}
                                                                        name={[fieldInner.name, 'url']}
                                                                        fieldKey={[fieldInner.key, 'url']}
                                                                        rules={FormFieldRules.BREACH.default}
                                                                        key={'source_form_' + index + '_' + sourceIndex + '_url'}
                                                                    >
                                                                        <TextArea
                                                                            placeholder="Source Url"
                                                                            disabled={viewOnly || locked}
                                                                        ></TextArea>
                                                                    </Form.Item>
                                                                    <CloseOutlined
                                                                        key={'source_form_' + index + '_' + sourceIndex + '_close'}
                                                                        onClick={() => remove(fieldInner.name)}
                                                                        style={{ fontSize: fontSize }}
                                                                    />
                                                                </Space>
                                                            ))}
                                                            <Form.Item>
                                                                <Button
                                                                    type="dashed"
                                                                    size={SIZE.SMALL}
                                                                    onClick={() => add()}
                                                                    block
                                                                    icon={<PlusOutlined />}
                                                                >
                                                                    Add Source
                                                                </Button>
                                                                <Form.ErrorList errors={errors} />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Form.List>
                                            </div>
                                            <MinusCircleOutlined onClick={() => remove(field.name)} />
                                        </Space>
                                        <Divider />
                                    </div>
                                ))}
                                <Form.Item>
                                    <Button
                                        type="dashed"
                                        size={SIZE.SMALL}
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                        disabled={viewOnly || locked}
                                    >
                                        Add New Breach
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Col>
            </Row>
        </Card>
    );
};

const GDPR = (props) => {
    const gdprQuestions = props.gdprQuestions;
    const gdprDataName = 'AppInfo.GdprResearchData.';

    return (
        <>
            <Row>
                <Col span={24}>
                    <Divider orientation="left">GDPR</Divider>
                    {gdprQuestions.map((ques) => {
                        return (
                            <>
                                {mlHiddenList.includes(ques.question_col_name) && props.mlHidden == false ? null : (
                                    <Card size={SIZE.SMALL} title={ques.question_text} style={{ marginBottom: '5px' }}>
                                        <GDPRQuestionRow
                                            ques={ques}
                                            securityIndex={securityIndex}
                                            form={props.form}
                                            viewOnly={props.viewOnly}
                                            gdprDataName={gdprDataName}
                                            allLocked={RESTRICT.allLocked || RESTRICT.allAttributeLocked}
                                        />
                                    </Card>
                                )}
                            </>
                        );
                    })}
                </Col>
            </Row>
        </>
    );
};

const GDPRQuestionRow = (props) => {
    const ques = props.ques;
    const securityIndex = props.securityIndex;
    const viewOnly = props.viewOnly;
    const gdprDataName = props.gdprDataName;

    let iniLocked = false;
    if (nsCciDB?.restrict_data) {
        if (nsCciDB?.restrict_data?.restrict_attributes.includes(ques.question_col_name) || props.allLocked) iniLocked = true;
    }

    const [locked, setLocked] = useState(iniLocked);

    const resetField = (question) => {
        props.form.resetFields([gdprDataName + question]);
    };

    const setRestrictLock = async (ques) => {
        const result = await researchUI({
            function: ResearchUIFunction.SET_RESTRICT_DATA,
            application_id: ID,
            attribute: ques.question_col_name,
            locked: !locked,
        });
        if (result.success === 1) {
            message.success('Successfully Saved');
            setLocked(!locked);
        } else {
            message.error(result.msg);
        }
    };

    const onClickLock = (ques) => {
        if (!props.allLocked) {
            setRestrictLock(ques);
        }
    };

    return (
        <Row>
            <Col span={8}>
                {ques.multi_valued ? (
                    <Form.Item name={gdprDataName + ques.question_col_name} size={SIZE.SMALL}>
                        <Checkbox.Group style={{ lineHeight: '0.5' }} disabled={viewOnly}>
                            <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                {ques.AppIndexQuestionChoices.map((choice) => {
                                    return (
                                        <>
                                            <Checkbox value={choice.choice_value} style={{ fontSize: fontSize }}>
                                                {choice.choice_text == '' ? choice.choice_value : choice.choice_text}
                                            </Checkbox>
                                        </>
                                    );
                                })}
                            </Space>
                        </Checkbox.Group>
                    </Form.Item>
                ) : (
                    <Form.Item name={gdprDataName + ques.question_col_name}>
                        <Radio.Group disabled={viewOnly || locked}>
                            <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                {ques.GdprQuestionChoices.map((choice) => {
                                    return (
                                        <>
                                            <Radio value={choice.choice_value} style={{ fontSize: fontSize }}>
                                                {choice.choice_text == '' ? choice.choice_value : choice.choice_text}
                                            </Radio>
                                        </>
                                    );
                                })}
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                )}
            </Col>
            <Col span={16}>
                <Space direction={ANTD_SPACE.DIRECTION_VERTICAL} style={{ width: '100%' }}>
                    <Row>
                        <Col span={1}>
                            <Button onClick={() => resetField(ques.question_col_name)}>
                                <UndoOutlined />
                            </Button>
                            {ALLOWEDROLE.includes(ROLE) ? (
                                <Button onClick={() => onClickLock(ques)}>
                                    {locked ? <LockOutlined style={{ color: 'red' }} /> : <UnlockOutlined style={{ color: 'green' }} />}
                                </Button>
                            ) : null}
                        </Col>
                        <Col span={23}>
                            <Form.Item name={'SecurityIndex.AppSourceInfo.' + ques.question_col_name + 'Text'}>
                                <Input.TextArea showCount autoSize={true} disabled={viewOnly || locked}></Input.TextArea>
                            </Form.Item>
                        </Col>
                    </Row>

                    <MlValidate
                        ques={ques}
                        securityIndex={securityIndex}
                        form={props.form}
                        quesType={'gdpr'}
                        quesFieldText={'SecurityIndex.AppSourceInfo.' + ques.question_col_name + 'Text'}
                        viewOnly={viewOnly || locked}
                    />
                </Space>
            </Col>
        </Row>
    );
};

const BasicInfo = (props) => {
    const DBName = 'AppInfo';
    const form = props.form;
    const [appLogoUrl, setAppLogoUrl] = useState(appInfoData?.AppLogo?.appLogoURL);
    const [appFavIconUrl, setAppFavIconUrl] = useState(appInfoData?.AppLogo?.fav_icon_logo_url);
    const [cityNameList, setCityNameList] = useState([{ value: 'Not Found', label: 'Not Found' }]);
    const [cityLoading, setCityLoading] = useState(true);
    const [descProhabitedWords, setDescProhabitedWords] = useState('');
    const [hintModalVis, setHintModalVis] = useState(false);
    const [hintModalTitle, setHintModalTitle] = useState('');
    const [hintModalBody, setHintModalBody] = useState(<></>);
    const [logoModalVis, setLogoModalVis] = useState(false);
    const [uploadedLogoUrl, setUploadedLogoUrl] = useState('');

    useEffect(() => {
        if (props.onlyOnce.current) {
            return;
        }
        onChangeDesc(props.form.getFieldValue('AppInfo.Applications.description'));
        if (appFavIconUrl == null || appFavIconUrl == '' || appFavIconUrl == undefined) {
            let favu = 'http://www.google.com/s2/favicons?domain=' + appInfoData?.AppUrl?.url;
            setAppFavIconUrl(favu);
            props.form.setFieldsValue({ 'AppInfo.AppLogo.fav_icon_logo_url': favu });
        }
        props.onlyOnce.current = true;
    }, [ID]);

    useEffect(() => {
        if (appInfoData?.ResearchData?.countries != 'select') {
            getCity(appInfoData?.ResearchData?.countries, appInfoData?.ResearchData?.city_id, 'city_id');
        }
    }, [ID]);

    const onChangeLogoLink = (e) => {
        setAppLogoUrl(e.target.value);
    };

    const onChangeFavLink = (e) => {
        setAppFavIconUrl(e.target.value);
    };

    const getCity = async (country, city, filterBy) => {
        if (!country) {
            setCityLoading(false);
            return;
        }
        const result = await researchUI({
            function: ResearchUIFunction.GET_CITY_BY_COUNTRY,
            country_code: countryCodes[country],
            city: city ? city : null,
            filterBy: filterBy,
        });

        let cityList = [{ value: 'Not Found', label: 'Not Found' }];
        let x = result?.data?.cities?.map((i) => {
            cityList.push({ value: '' + i.city_id, label: i.city + ',' + i.region });
            return;
        });
        setCityNameList(cityList);
        setCityLoading(false);
    };
    const onChangeCountry = (e) => {
        setCityLoading(true);
        if (e != 'select') {
            getCity(e, null, null);
        }
    };

    const onCityNameSearch = (value) => {
        if (value.length > 2) {
            getCity(props.form.getFieldValue(DBName + '.ResearchData.countries'), value, 'city');
        }
    };

    const onChangeDesc = (e) => {
        let words = e.split(' ').map((i) => i.toLowerCase());
        let prohWordsFound = [];
        words.map((w) => {
            if (descProhabitedWordsList.includes(w)) {
                prohWordsFound.push(w);
            }
        });
        setDescProhabitedWords(prohWordsFound.join());
    };

    const onRemoveFile = (files) => {
        const removeFile = async () => {
            const result = await researchUI({
                function: ResearchUIFunction.DELETE_FILES,
                application_id: ID,
                filename: files.name,
            });
            if (result.success == 1) {
                message.success(result.msg);
            } else {
                message.danger(result.msg);
                return false;
            }
        };
        return removeFile();
    };

    const authenticatedDownload = async (file) => {
        try {
            const res = await fetch(file.url, {
                credentials: 'include',
            });
            if (!res.ok) throw new Error(`Download failed: ${res.status}`);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error(err);
            message.error('Failed to download file');
        }
    };

    const showHintModal = (hintType) => {
        if (hintType == 'LoginPageURL' || hintType == 'TOS') {
            setHintModalTitle('URL Hints');
            setHintModalBody(
                <Table
                    columns={[
                        {
                            title: '',
                            render: (text, record) => (
                                <Button
                                    icon={<SelectOutlined />}
                                    onClick={() => {
                                        let x = {};
                                        if (hintType == 'LoginPageURL') x['AppInfo.ResearchData.LoginPageURL'] = record.hintText;
                                        if (hintType == 'TOS') x['AppInfo.ResearchData.TOS'] = record.hintText;
                                        form.setFieldsValue(x);
                                        setHintModalVis(false);
                                    }}
                                />
                            ),
                        },
                        {
                            title: 'Hint Text',
                            dataIndex: 'hintText',
                            key: 'hintText',
                            render: (text, record) =>
                                safeHref(text) ? (
                                    <a href={safeHref(text)} target="_blank">
                                        {text}
                                    </a>
                                ) : (
                                    <span>{text}</span>
                                ),
                        },
                    ]}
                    dataSource={mlProofData[hintType].map((i) => {
                        return { hintText: i.links };
                    })}
                    bordered
                    style={{ fontSize: fontSize }}
                />
            );
        }

        if (hintType == 'Address') {
            setHintModalTitle('Address Hints');
            setHintModalBody(
                <Table
                    columns={[
                        {
                            title: '',
                            render: (text, record) => (
                                <Button
                                    icon={<SelectOutlined />}
                                    onClick={() => {
                                        let x = {};
                                        x['SecurityIndex.AppSourceInfo.appCompanyAddressText'] = record.hintText;
                                        x['SecurityIndex.AppSourceInfo.countriesText'] = record.hintLink;
                                        form.setFieldsValue(x);
                                        setHintModalVis(false);
                                    }}
                                />
                            ),
                        },
                        {
                            title: 'Hint Link',
                            dataIndex: 'hintLink',
                            key: 'hintLink',
                            render: (text, record) =>
                                safeHref(text) ? (
                                    <a href={safeHref(text)} target="_blank">
                                        {text}
                                    </a>
                                ) : (
                                    <span>{text}</span>
                                ),
                        },
                        {
                            title: 'Hint Text',
                            dataIndex: 'hintText',
                            key: 'hintText',
                        },
                    ]}
                    dataSource={mlProofData[hintType].map((i) => {
                        return { hintLink: i.links, hintText: i.proof_text };
                    })}
                    bordered
                    style={{ fontSize: fontSize }}
                />
            );
        }
        setHintModalVis(true);
    };

    const onHintModalClose = () => {
        setHintModalVis(false);
    };

    const onLogoModalClose = () => {
        setLogoModalVis(false);
    };

    const onChangeLogo = (info) => {
        if (info.file.status === 'done') {
            if (info?.file?.response?.success) {
                setUploadedLogoUrl(info?.file?.response?.data?.url);
            } else {
                message.error('Something Went Wrong');
            }
        }
        if (info.file.status === 'error') {
            message.error('Error in uploading');
        }
    };

    return (
        <>
            <Row gutter={[16, 16]} style={{ marginTop: '5px' }}>
                <Col span={24}>
                    <Card title="App Logo, Fav Icon, Comments & Uploaded" {...cardProp}>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Space direction={ANTD_SPACE.DIRECTION_VERTICAL} style={{ width: '100%' }}>
                                    <Row align={'middle'}>
                                        <Col span={15}>
                                            <Image preview={false} src={appLogoUrl} fallback={DefaultLogoImg} />
                                        </Col>
                                        <Col span={1} offset={1}>
                                            <Divider type="vertical" style={{ height: '50px', backgroundColor: 'grey' }} />
                                        </Col>
                                        <Col span={6} offset={1}>
                                            <Image preview={false} src={appFavIconUrl} fallback={DefaultLogoImg} />
                                        </Col>
                                    </Row>
                                    <Space direction={ANTD_SPACE.DIRECTION_VERTICAL} size={[1, 1]} style={{ width: '100%' }}>
                                        <Row gutter={[8, 0]}>
                                            <Col span={23}>
                                                <Form.Item name={DBName + '.AppLogo.appLogoURL'}>
                                                    <Input
                                                        size={SIZE.SMALL}
                                                        type="text"
                                                        placeholder="Place Logo Link"
                                                        addonBefore={'Logo'}
                                                        style={{ width: '100%' }}
                                                        onChange={onChangeLogoLink}
                                                        disabled={props.viewOnly}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={1}>
                                                <UploadOutlined
                                                    onClick={() => {
                                                        setLogoModalVis(true);
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                        <Form.Item name={DBName + '.AppLogo.fav_icon_logo_url'}>
                                            <Input
                                                size={SIZE.SMALL}
                                                type="text"
                                                placeholder="Place Logo Link"
                                                addonBefore={'Fav'}
                                                value={appFavIconUrl}
                                                onChange={onChangeFavLink}
                                                disabled={props.viewOnly}
                                            />
                                        </Form.Item>
                                    </Space>
                                </Space>
                            </Col>
                            <Col span={8}>
                                <Divider className={styles.dividerSmall}>Comments For This App</Divider>
                                <Form.Item name={'SecurityIndex.AppSourceInfo.completionStatusText'}>
                                    <Input.TextArea autoSize={{ minRows: 4, maxRows: 6 }} disabled={props.viewOnly}></Input.TextArea>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Divider className={styles.dividerSmall}>
                                    <Upload
                                        action={apiUrl.uri1 + 'custom/upload'}
                                        name="pdfFiles"
                                        onRemove={onRemoveFile}
                                        defaultFileList={securityIndex?.AppUploadedFiles?.map((i) => {
                                            return {
                                                name: i.uploaded_file,
                                                status: 200,
                                                url: apiUrl.uri1 + 'custom/download/' + i.uploaded_file,
                                            };
                                        })}
                                        data={(file) => {
                                            return {
                                                application_id: ID,
                                                user: props.user.name,
                                                email: props.user.email,
                                            };
                                        }}
                                        disabled={props.viewOnly}
                                        withCredentials={true}
                                        showUploadList={{ showDownloadIcon: true, showRemoveIcon: !props.viewOnly }}
                                        onPreview={authenticatedDownload}
                                        onDownload={authenticatedDownload}
                                    >
                                        <a style={{ fontSize: fontSize }} disabled={props.viewOnly}>
                                            Upload Files
                                        </a>
                                    </Upload>
                                </Divider>
                            </Col>
                        </Row>
                    </Card>
                </Col>

                <Col span={24}>
                    <Card title="About Us" {...cardProp}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Divider className={styles.dividerSmall}>Description</Divider>
                                <Space direction={ANTD_SPACE.DIRECTION_VERTICAL} style={{ width: '100%' }} size={1}>
                                    <Form.Item name={DBName + '.Applications.description'} rules={FormFieldRules.BASIC_INFO.description}>
                                        <Input.TextArea
                                            size={SIZE.SMALL}
                                            showCount
                                            autoSize={{ minRows: 4, maxRows: 4 }}
                                            style={{ fontSize: fontSize }}
                                            onChange={(e) => onChangeDesc(e.target.value)}
                                            disabled={props.viewOnly}
                                        />
                                    </Form.Item>
                                    <Text type="danger">{descProhabitedWords}</Text>
                                </Space>
                            </Col>
                            <Col span={12}>
                                <Divider className={styles.dividerSmall}>Proof Of Description</Divider>
                                <Form.Item name={DBName + '.ResearchData.AboutText'}>
                                    <Input.TextArea
                                        size={SIZE.SMALL}
                                        showCount
                                        autoSize={{ minRows: 4, maxRows: 4 }}
                                        style={{ fontSize: fontSize }}
                                        disabled={props.viewOnly}
                                    ></Input.TextArea>
                                </Form.Item>
                            </Col>
                            <Col span={12}></Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Divider className={styles.dividerSmall}>Company Name</Divider>
                                <Form.Item name={DBName + '.ResearchData.appcompanyname'}>
                                    <Input disabled={props.viewOnly} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Divider className={styles.dividerSmall}>Business HeadQuarters</Divider>
                                <Form.Item name={DBName + '.ResearchData.countries'}>
                                    <Select
                                        showSearch
                                        allowClear
                                        optionFilterProp="label"
                                        options={countryList}
                                        filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={onChangeCountry}
                                        autoComplete="none"
                                        disabled={props.viewOnly}
                                    ></Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Divider className={styles.dividerSmall}>City Name</Divider>
                                <Form.Item name={DBName + '.ResearchData.city_id'}>
                                    <Select
                                        showSearch
                                        loading={cityLoading}
                                        optionFilterProp="label"
                                        options={cityNameList}
                                        disabled={cityLoading || props.viewOnly}
                                        filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        autoComplete="none"
                                        onSearch={onCityNameSearch}
                                    ></Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={mlProofData?.Address ? 2 : 16} align="middle">
                            <Col flex="auto">
                                <Divider className={styles.dividerSmall}>Company Address</Divider>
                                <Form.Item name={'SecurityIndex.AppSourceInfo.appCompanyAddressText'}>
                                    <Input.TextArea
                                        showCount
                                        autoSize={{ minRows: 4, maxRows: 4 }}
                                        disabled={props.viewOnly}
                                    ></Input.TextArea>
                                </Form.Item>
                            </Col>
                            {mlProofData?.Address ? (
                                <Col>
                                    <Button onClick={() => showHintModal('Address')}>
                                        <HddTwoTone />
                                    </Button>
                                </Col>
                            ) : (
                                ''
                            )}
                            <Col flex="auto">
                                <Divider className={styles.dividerSmall}>Proof for Address</Divider>
                                <Form.Item name={'SecurityIndex.AppSourceInfo.countriesText'}>
                                    <Input.TextArea
                                        showCount
                                        autoSize={{ minRows: 4, maxRows: 4 }}
                                        disabled={props.viewOnly}
                                    ></Input.TextArea>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Col>

                <Col span={24}>
                    <Card>
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Divider className={styles.dividerSmall}>Login Page</Divider>
                                <Row>
                                    <Col flex="auto">
                                        <Form.Item name={DBName + '.ResearchData.LoginPageURL'}>
                                            <Input size={SIZE.SMALL} disabled={props.viewOnly}></Input>
                                        </Form.Item>
                                    </Col>
                                    {mlProofData?.LoginPageURL ? (
                                        <Col>
                                            <Button onClick={() => showHintModal('LoginPageURL')}>
                                                <HddTwoTone />
                                            </Button>
                                        </Col>
                                    ) : (
                                        ''
                                    )}
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Divider className={styles.dividerSmall}>Credential Used For Login</Divider>
                                <Form.Item style={{ marginBottom: '2px' }} name={DBName + '.ResearchData.username'}>
                                    <Input placeholder="Username" disabled={props.viewOnly}></Input>
                                </Form.Item>
                                <Form.Item name={DBName + '.ResearchData.password'}>
                                    <Input placeholder="Password" disabled={props.viewOnly}></Input>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card>
                        <Row gutter={[16, 16]}>
                            <MLCategory />
                            <Col flex="auto">
                                <Divider className={styles.dividerSmall}>Terms and Service</Divider>
                                <Row>
                                    <Col flex="auto">
                                        <Form.Item name={DBName + '.ResearchData.TOS'}>
                                            <Input disabled={props.viewOnly}></Input>
                                        </Form.Item>
                                    </Col>
                                    {mlProofData?.TOS ? (
                                        <Col>
                                            <Button onClick={() => showHintModal('TOS')}>
                                                <HddTwoTone />
                                            </Button>
                                        </Col>
                                    ) : (
                                        ''
                                    )}
                                </Row>
                            </Col>
                            <Col flex="auto">
                                <Divider className={styles.dividerSmall}>App Type</Divider>
                                <Form.Item name={DBName + '.ResearchData.app_type'}>
                                    <Radio.Group disabled={props.viewOnly}>
                                        <Space size={[2, 2]} direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                            <Radio value="Consumer" style={{ fontSize: fontSize }}>
                                                Consumer
                                            </Radio>
                                            <Radio value="Departmental" style={{ fontSize: fontSize }}>
                                                Departmental
                                            </Radio>
                                            <Radio value="Enterprise" style={{ fontSize: fontSize }}>
                                                Enterprise
                                            </Radio>
                                        </Space>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                {ALLOWEDROLE.includes(ROLE) ? (
                    <Col span={24}>
                        <Card title={'Restriction Control'}>
                            <Form.Item name={'restrict'}>
                                <Checkbox.Group>
                                    <Checkbox value={'all'}>All</Checkbox>
                                    <Checkbox value={'all_attributes'}>All Attributes</Checkbox>
                                    <Checkbox value={'category'}>Category</Checkbox>
                                </Checkbox.Group>
                            </Form.Item>
                            <Form.Item name={'restrictComment'}>
                                <Input.TextArea autoSize={{ minRows: 4, maxRows: 6 }} size={'small'}></Input.TextArea>
                            </Form.Item>
                        </Card>
                    </Col>
                ) : null}

                <Col span={24}>
                    <Collapse collapsible="header" defaultActiveKey={appInfoData.ResearchData.customtag.length > 0 ? '1' : null}>
                        <Panel
                            header={
                                <>
                                    <Text>Custom Tagging </Text>
                                    <Text style={{ fontSize: '8px' }}>(click to expand.)</Text>
                                </>
                            }
                            key="1"
                            showArrow={false}
                        >
                            {/*Custom Tagging*/}
                            <Form.Item name={DBName + '.ResearchData.customtag'}>
                                <Checkbox.Group style={{ width: '100%' }} disabled={props.viewOnly}>
                                    <Row gutter={4}>
                                        <Col span={4}>
                                            <Card title="Priority" {...cardProp} bodyStyle={{ paddingLeft: '5px', paddingRight: '5px' }}>
                                                <Space>
                                                    <Checkbox value="custom_p1" style={{ fontSize: fontSize }}>
                                                        P1
                                                    </Checkbox>
                                                    <Checkbox value="custom_p2" style={{ fontSize: fontSize }}>
                                                        P2
                                                    </Checkbox>
                                                    <Checkbox value="custom_p3" style={{ fontSize: fontSize }}>
                                                        P3
                                                    </Checkbox>
                                                </Space>
                                            </Card>
                                        </Col>
                                        <Col span={5}>
                                            <Card
                                                title="Customer Request"
                                                {...cardProp}
                                                bodyStyle={{ paddingLeft: '5px', paddingRight: '5px' }}
                                            >
                                                <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                                    <Checkbox value="custom_customer" style={{ fontSize: fontSize }}>
                                                        Customer Requested App
                                                    </Checkbox>
                                                    <Checkbox value="custom_customer_new" style={{ fontSize: fontSize }}>
                                                        Customer Requested New App
                                                    </Checkbox>
                                                </Space>
                                            </Card>
                                        </Col>
                                        <Col span={4}>
                                            <Card
                                                title="Vendor Response"
                                                {...cardProp}
                                                bodyStyle={{ paddingLeft: '5px', paddingRight: '5px' }}
                                            >
                                                <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                                                    <Checkbox value="vendor_response" style={{ fontSize: fontSize }}>
                                                        Vendor Response
                                                    </Checkbox>
                                                    <Checkbox value="vendor_response_jp" style={{ fontSize: fontSize }}>
                                                        Vendor Response Japan
                                                    </Checkbox>
                                                </Space>
                                            </Card>
                                        </Col>
                                        <Col span={8}>
                                            <Card title="App Tag" {...cardProp} bodyStyle={{ paddingLeft: '5px', paddingRight: '5px' }}>
                                                <Space size={[2, 2]} wrap>
                                                    <Checkbox value="custom_TE" style={{ fontSize: fontSize }}>
                                                        TE (tail end apps)
                                                    </Checkbox>
                                                    <Checkbox value="custom_AppSuite" style={{ fontSize: fontSize }}>
                                                        AppSuite
                                                    </Checkbox>
                                                    <Checkbox value="custom_GMP" style={{ fontSize: fontSize }}>
                                                        GMP
                                                    </Checkbox>
                                                    <Checkbox value="custom_sfdc" style={{ fontSize: fontSize }}>
                                                        SFDC
                                                    </Checkbox>
                                                    <Checkbox value="custom_tpt" style={{ fontSize: fontSize }}>
                                                        TPT (ThirdPartyTrust)
                                                    </Checkbox>
                                                    <Checkbox value="non_english" style={{ fontSize: fontSize }}>
                                                        Non English
                                                    </Checkbox>
                                                </Space>
                                            </Card>
                                        </Col>
                                        <Col span={3}>
                                            <Card
                                                title="User Defined"
                                                {...cardProp}
                                                bodyStyle={{ paddingLeft: '5px', paddingRight: '5px' }}
                                            >
                                                <Input></Input>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Checkbox.Group>
                            </Form.Item>
                        </Panel>
                    </Collapse>
                </Col>

                <Col span={24}>
                    <Collapse collapsible="header">
                        <Panel
                            header={
                                <>
                                    <Text>Contact Info </Text>
                                    <Text style={{ fontSize: '8px' }}>(click to expand.)</Text>
                                </>
                            }
                            key="1"
                            showArrow={false}
                        >
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Divider className={styles.dividerSmall}>Name</Divider>
                                    <Form.Item name={'SecurityIndex.AppContactInfo.contact_name1'}>
                                        <Input placeholder="Name" disabled={props.viewOnly} />
                                    </Form.Item>
                                    <Form.Item name={'SecurityIndex.AppContactInfo.contact_name2'}>
                                        <Input placeholder="Name" disabled={props.viewOnly} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Divider className={styles.dividerSmall}>Email</Divider>
                                    <Form.Item name={'SecurityIndex.AppContactInfo.contact_email1'}>
                                        <Input placeholder="Email" disabled={props.viewOnly} />
                                    </Form.Item>
                                    <Form.Item name={'SecurityIndex.AppContactInfo.contact_email2'}>
                                        <Input placeholder="Email" disabled={props.viewOnly} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                </Col>
                <Col span={24}>
                    <Collapse collapsible="header">
                        <Panel
                            header={
                                <>
                                    <Text>Pricing </Text>
                                    <Text style={{ fontSize: '8px' }}>(click to expand.)</Text>
                                </>
                            }
                            key="1"
                            showArrow={false}
                            extra={
                                <Form.Item
                                    name={DBName + '.ResearchData.pricing_currency'}
                                    label={<Text style={{ fontSize: fontSize, fontWeight: '200' }}>Currency</Text>}
                                >
                                    <Select
                                        size={SIZE.SMALL}
                                        allowClear
                                        showSearch
                                        style={{ width: '100px' }}
                                        optionFilterProp="value"
                                        filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        disabled={props.viewOnly}
                                    >
                                        <Option value=""></Option>;
                                        {currencyList.map((i) => {
                                            return (
                                                <Option key={'option_' + i} value={i}>
                                                    {i}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                            }
                        >
                            <Row gutter={2}>
                                <Col span={12}>
                                    <Divider className={styles.dividerSmall}>Pricing Name</Divider>
                                    <Form.Item name={DBName + '.ResearchData.pricing_tier_one_name'}>
                                        <Input placeholder="Pricing Name" disabled={props.viewOnly} />
                                    </Form.Item>
                                    <Form.Item name={DBName + '.ResearchData.pricing_tier_two_name'}>
                                        <Input placeholder="Pricing Name" disabled={props.viewOnly} />
                                    </Form.Item>
                                    <Form.Item name={DBName + '.ResearchData.pricing_tier_three_name'}>
                                        <Input placeholder="Pricing Name" disabled={props.viewOnly} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Divider className={styles.dividerSmall}>Price</Divider>
                                    <Form.Item name={DBName + '.ResearchData.pricing_tier_one_cost'}>
                                        <Input placeholder="Price" style={{ width: '100%' }} defaultValue={'0'} disabled={props.viewOnly} />
                                    </Form.Item>
                                    <Form.Item name={DBName + '.ResearchData.pricing_tier_two_cost'}>
                                        <Input placeholder="Price" style={{ width: '100%' }} defaultValue={'0'} disabled={props.viewOnly} />
                                    </Form.Item>
                                    <Form.Item name={DBName + '.ResearchData.pricing_tier_three_cost'}>
                                        <Input placeholder="Price" style={{ width: '100%' }} defaultValue={'0'} disabled={props.viewOnly} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Form.Item name={'SecurityIndex.AppSourceInfo.priceText'}>
                                        <TextArea placeholder="Pricing Info" disabled={props.viewOnly}></TextArea>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
            <Modal title={hintModalTitle} visible={hintModalVis} onCancel={onHintModalClose} width={'70%'}>
                {hintModalBody}
            </Modal>
            <Modal title={'Upload Logo'} visible={logoModalVis} onCancel={onLogoModalClose} width={'70%'}>
                <Space size={16} align={ANTD_SPACE.ALIGN_CENTER}>
                    <Upload
                        action={apiUrl.uri1 + 'custom/uploadlogo'}
                        name="logo"
                        withCredentials={true}
                        disabled={props.viewOnly}
                        onChange={onChangeLogo}
                        showUploadList={false}
                    >
                        <Button icon={<UploadOutlined />} disabled={props.viewOnly}>
                            Click to Upload
                        </Button>
                    </Upload>
                    {uploadedLogoUrl === '' ? '' : <Paragraph copyable>{uploadedLogoUrl}</Paragraph>}
                </Space>
            </Modal>
        </>
    );
};

const MLCategory = (props) => {
    const [disCat, setDisCat] = useState(securityIndex?.ResearchAutomationAppCategory?.selected_category == null ? false : true);

    const onMlCategoryChange = (value) => {
        if (
            value != securityIndex?.ResearchAutomationAppCategory?.primary_category &&
            value != securityIndex?.ResearchAutomationAppCategory?.secondary_category
        ) {
            message.warning('Selected Ml Category is not from suggested Ml Category.');
        }
    };

    return (
        <>
            {securityIndex?.ResearchAutomationAppCategory ? (
                <Col flex="auto">
                    <Tooltip title="Click on disabled Ml Category to change." overlayInnerStyle={{ fontSize: fontSize }}>
                        <Divider className={styles.dividerSmall}>Ml Category</Divider>
                    </Tooltip>
                    <Popconfirm
                        title="Do you want to enable Ml Category."
                        okText="Enable"
                        cancelText="Cancel"
                        onConfirm={() => setDisCat(false)}
                        disabled={!disCat}
                    >
                        <Form.Item style={{ marginBottom: '2px' }} name={'SecurityIndex.ResearchAutomationAppCategory.selected_category'}>
                            <Select
                                showSearch
                                options={categoryList}
                                optionFilterProp="label"
                                filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                                onChange={onMlCategoryChange}
                                disabled={disCat}
                            ></Select>
                        </Form.Item>
                    </Popconfirm>
                    <Space direction={ANTD_SPACE.DIRECTION_VERTICAL} size={2}>
                        <Text style={{ fontSize: fontSize }}>
                            <Text style={{ fontWeight: '500' }}>Primary Category: </Text>
                            {securityIndex?.ResearchAutomationAppCategory?.primary_category}
                        </Text>

                        <Text style={{ fontSize: fontSize }}>
                            <Text style={{ fontWeight: '500' }}>Secondary Category: </Text>
                            {securityIndex?.ResearchAutomationAppCategory?.secondary_category}
                        </Text>
                    </Space>
                </Col>
            ) : (
                ''
            )}
        </>
    );
};

const ApplicationInfo = (props) => {
    const appInfoData = props.appInfoData;
    const [statusDrpVis, setStatusDrpVis] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [modalVis, setModalVis] = useState(false);
    const [okBtnCall, setOkBtnCall] = useState(false);

    const onStatusSelect = (item) => {
        setStatusDrpVis(!statusDrpVis);
        const validator = async () => {
            let reviewed = false;
            if (
                completionStatus[parseInt(item.key)].includes(AppCompletionStatus.APP_ALL_COMPLETE) ||
                completionStatus[parseInt(item.key)].includes(AppCompletionStatus.APP_FOR_DISCOVERY_ONLY)
            ) {
                reviewed = window.confirm('Are you reviewd this app completely');
            }
            const result = await researchUI({
                function: ResearchUIFunction.VALIDATE_SUBMITED_DATA,
                application_id: ID,
                app_status: completionStatus[parseInt(item.key)],
                old_app_status: appInfoData.ResearchData.completionStatus,
                reviewed: reviewed,
            });
            if (result.success == 1) {
                message.success(result.msg, 3).then(() => {
                    const reload = () => window.location.reload();
                    reload();
                });
            } else {
                let msg = (
                    <Space direction={ANTD_SPACE.DIRECTION_VERTICAL}>
                        {result.data.map((i) => {
                            return <Text key={i}>{i}</Text>;
                        })}
                    </Space>
                );
                message.error(msg, 5);
            }
        };
        let valueChanged = props.valueChanged;
        let valueFlag = false;
        Object.keys(valueChanged).map((i) => {
            Object.keys(valueChanged[i]).map((j) => {
                if (Object.keys(valueChanged[i][j]).length > 0) valueFlag = true;
            });
        });
        if (!valueFlag) {
            validator();
        } else {
            message.error('Please save changes first.');
        }
    };

    const onSubmit = () => {
        setStatusDrpVis(!statusDrpVis);
    };
    const completionStatusMenus = () => {
        return (
            <Menu onClick={onStatusSelect}>
                {completionStatus.map((status, i) => {
                    return <Menu.Item key={i}>{status}</Menu.Item>;
                })}
            </Menu>
        );
    };
    const drawerShow = () => {
        setShowDrawer(true);
    };
    const onDrawerClose = () => {
        setShowDrawer(false);
    };
    const onMlHiddenSwitchChange = (checked) => {
        props.setMlHidden(checked);
    };
    const onModalClose = () => {
        setModalVis(false);
    };
    return (
        <>
            <Row align={'middle'} style={{ backgroundColor: 'white', borderBottom: '1px solid grey' }}>
                <Col span={19}>
                    <Row style={{ padding: '0px' }} align="middle" wrap={false}>
                        <Col span={3}>
                            <Row>
                                <Col span={14}>
                                    <Image src={'data:image/jpeg;base64,' + appInfoData?.AppLogo?.application_logo} />
                                </Col>
                                <Col span={6} offset={2}>
                                    <Image src={'data:image/jpeg;base64,' + appInfoData?.AppLogo?.fav_icon_logo} />
                                </Col>
                                <Col span={2}></Col>
                            </Row>
                        </Col>
                        <Col key={'temp'} span={18} offset={1}>
                            <Descriptions size={SIZE.SMALL} column={2} style={{ fontSize: fontSize }}>
                                {Object.entries(props.appData).map(([key, value]) => {
                                    if (value.tagType == 'Tag' && value.value != null) {
                                        return (
                                            <Descriptions.Item label={value.title} style={{ fontSize: fontSize }} key={'app_info_' + key}>
                                                <Text>
                                                    {value?.link && safeHref(value.value) ? (
                                                        <Link href={safeHref(value.value)} target="_blank">
                                                            {value.value}
                                                        </Link>
                                                    ) : (
                                                        value.value
                                                    )}
                                                    <CopyToClipboard text={value.value}>
                                                        <CopyTwoTone />
                                                    </CopyToClipboard>
                                                </Text>
                                            </Descriptions.Item>
                                        );
                                    }
                                })}
                            </Descriptions>
                        </Col>
                        <Col span={2}>
                            <Link style={{ fontSize: fontSize }} onClick={drawerShow}>
                                More Info
                            </Link>
                        </Col>
                    </Row>
                </Col>
                <Col flex="auto" span={4}>
                    <Space align={ANTD_SPACE.ALIGN_CENTER} direction={ANTD_SPACE.DIRECTION_HORIZONTAL}>
                        {appInfoData.ResearchData.customtag.includes('custom_p1') ? (
                            <Avatar style={{ backgroundColor: '#ff8300' }}>P1</Avatar>
                        ) : null}
                        {appInfoData.ResearchData.customtag.includes('custom_p2') ? (
                            <Avatar style={{ backgroundColor: '#ff8300' }}>P2</Avatar>
                        ) : null}
                        {props.viewOnly ? null : (
                            <Space align={ANTD_SPACE.ALIGN_CENTER} direction={ANTD_SPACE.DIRECTION_HORIZONTAL}>
                                <Form.Item style={{ margin: 'auto' }}>
                                    <Button
                                        type={props.unSaved ? 'primary' : ''}
                                        htmlType="submit"
                                        size={SIZE.SMALL}
                                        disabled={props.viewOnly}
                                    >
                                        Save
                                    </Button>
                                </Form.Item>
                                <Form.Item style={{ margin: 'auto' }} name={'Form.submit'}>
                                    <Dropdown
                                        overlay={completionStatusMenus}
                                        size={SIZE.SMALL}
                                        visible={statusDrpVis}
                                        onClick={onSubmit}
                                        disabled={props.viewOnly}
                                    >
                                        <Button>
                                            Submit <DownOutlined />
                                        </Button>
                                    </Dropdown>
                                </Form.Item>
                            </Space>
                        )}
                        <Switch
                            size={SIZE.SMALL}
                            checkedChildren="ML"
                            unCheckedChildren="ML"
                            defaultChecked={props.mlHidden}
                            onChange={onMlHiddenSwitchChange}
                        />
                    </Space>
                </Col>
            </Row>
            <Drawer title="More Info" placement="right" onClose={onDrawerClose} visible={showDrawer}>
                <Row>
                    <Col span={24}>
                        <Divider className={styles.dividerSmall} orientation="left">
                            Domains
                        </Divider>
                        <Text style={{ fontSize: fontSize }}>
                            {appInfoData.AppDomains.map((domain) => {
                                return domain.domain_name;
                            }).join()}
                        </Text>
                    </Col>
                    <Col span={24}>
                        <Divider className={styles.dividerSmall} orientation="left"></Divider>
                        <Descriptions column={1}>
                            {appInfoData?.CciTrend?.cci ? (
                                <Descriptions.Item label="CCI Score">{appInfoData?.CciTrend?.cci}</Descriptions.Item>
                            ) : (
                                ''
                            )}
                            {appInfoData.ResearchData.refreshedDate == '0000-00-00' ? (
                                ''
                            ) : (
                                <Descriptions.Item label="Last Reviewed">{appInfoData.ResearchData.refreshedDate}</Descriptions.Item>
                            )}
                            <Descriptions.Item label="Connector">{appInfoData.connector_support}</Descriptions.Item>
                            <Descriptions.Item label="ML Hidden Attribute Count">{mlHiddenList.length}</Descriptions.Item>
                            <Descriptions.Item label="Assigned To">{appInfoData?.ResearchData?.createdBy}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    <Col>
                        <Button
                            onClick={() => {
                                setModalVis(true);
                            }}
                        >
                            App Change Request
                        </Button>
                    </Col>
                    <Col>
                        <Button>
                            <Link href={'/searchpage'} target={'_blank'}>
                                Search Page
                            </Link>
                        </Button>
                    </Col>
                </Row>
                <Row style={{ position: 'absolute', bottom: '10px' }}>
                    <Col span={24}>
                        <Link
                            href="https://netskope.atlassian.net/wiki/spaces/ACC/pages/983435206/CCI+Manual+Research+Attributes+-+Reference+Guide"
                            target="_blank"
                            style={{ fontSize: fontSize }}
                        >
                            Reference Guide
                        </Link>
                    </Col>
                </Row>
            </Drawer>
            <Modal
                title="App Change Request"
                visible={modalVis}
                okText={'Submit'}
                onOk={() => setOkBtnCall(true)}
                onCancel={onModalClose}
                width={'80%'}
                destroyOnClose
            >
                <AppSubMission
                    appData={props.appData}
                    okBtn={okBtnCall}
                    modalVis={modalVis}
                    setOkBtn={setOkBtnCall}
                    setModalVis={onModalClose}
                />
            </Modal>
        </>
    );
};

const AppSubMission = (props) => {
    const appData = props.appData;
    const appName = appData.appName.value;
    const url = appData.url.value;
    const category = appData.category.value;
    const priority = appData.priority.value;
    const connector = appInfoData.connector_support;

    const initDefaultVal = {
        edit_AppName: appName,
        edit_URL: url,
        edit_Category: category,
    };
    const [loading, setLoading] = useState(false);
    const [initVal, setInitVal] = useState(initDefaultVal);
    const [tableData, setTableData] = useState([]);
    const [appExistTableData, setAppExistTableData] = useState([]);
    const [penReq, setPenReq] = useState(false);
    const [subReqForm] = Form.useForm();

    let categoryLocked = false;
    if (nsCciDB?.restrict_data?.restrict) {
        if (RESTRICT.category || RESTRICT.allLocked) {
            categoryLocked = true;
        }
    }
    useEffect(() => {
        if (props.okBtn == true) {
            if (!penReq) {
                subReqForm.submit();
            }
            props.setOkBtn(false);
        }
    }, [props.okBtn]);

    useEffect(() => {
        const pendingReq = async () => {
            setLoading(true);
            const result = await researchUI({
                function: ResearchUIFunction.GET_APP_CHANGES_REQ,
                application_id: ID,
                reqType: 'GetReqs',
            });
            let tableGen = [];
            let anyPen = false;
            result.data.pending.map((i) => {
                tableGen.push({ key: i.id, ...i });
                if (i.status == 'Pending') anyPen = true;
            });
            setTableData(tableGen);
            setPenReq(anyPen);
            setLoading(false);
        };
        pendingReq();
    }, [ID]);

    const onFinish = async (values) => {
        let changeIn = [];
        if (appName != values.edit_AppName) changeIn.push('AppName');
        if (url != values.edit_URL) changeIn.push('URL');
        if (category != values.edit_Category) changeIn.push('Category');
        if (changeIn.length > 0) {
            const sendChangeReq = async () => {
                const result = await researchUI({
                    function: ResearchUIFunction.APP_CHANGES,
                    application_id: ID,
                    req_type: 'EDIT',
                    appName: appName,
                    req_appName: values.edit_AppName.trim(),
                    url: url,
                    req_url: values.edit_URL.trim(),
                    category: category,
                    req_category: values.edit_Category,
                    changeIn: changeIn.toString(),
                    comments: values.edit_comments,
                    requestedBy: USERNAME,
                    status: 'Pending',
                    reqType: 'New',
                })
                    .then((result) => {
                        if (result.success == 1) {
                            message.success(result.msg);
                            return true;
                        } else {
                            message.error(result.msg);
                            setAppExistTableData(result.data.tableData);
                            return false;
                        }
                    })
                    .catch(() => {
                        message.error('Something went wrong.');
                        return false;
                    });
                if (result) props.setModalVis();
            };
            sendChangeReq();
        }
    };

    const catSelProp = {
        showSearch: true,
        options: categoryList,
        optionFilterProp: 'label',
        filterOption: (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        filterSort: (optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase()),
        style: { width: '300px' },
        size: 'small',
    };

    //Table Edit
    const [tableForm] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        tableForm.setFieldsValue({
            req_appName: '',
            req_url: '',
            req_category: '',
            ...record,
        });
        setEditingKey(record.key);
    };

    const save = async (key) => {
        try {
            const row = await tableForm.validateFields();
            const newData = [...tableData];
            const index = newData.findIndex((item) => key.key === item.key);
            if (index > -1) newData.splice(index, 1, { ...newData[index], ...row });
            else newData.push(row);
            let changeIn = [];
            if (appName != row.req_appName) changeIn.push('AppName');
            if (url != row.req_url) changeIn.push('URL');
            if (category != row.req_category) changeIn.push('Category');
            const updateTable = async () => {
                const result = await researchUI({
                    function: ResearchUIFunction.APP_CHANGES,
                    id: key.key,
                    application_id: ID,
                    reqType: 'Update',
                    changeIn: changeIn.toString(),
                    ...row,
                })
                    .then((result) => {
                        if (result.success == 1) {
                            setTableData(newData);
                            setAppExistTableData([]);
                            setEditingKey('');
                        } else {
                            setAppExistTableData(result.data.tableData);
                            message.error(result.data.msg);
                        }
                    })
                    .catch(() => message.error('Something Went Wrong.'));
            };
            updateTable();
        } catch (errInfo) {
            message.error('Validation Failed: ' + errInfo);
        }
    };

    const deleteReq = async (key) => {
        const newData = [...tableData];
        const index = newData.findIndex((item) => key.key === item.key);
        if (index > -1) newData.splice(index, 1);
        const deleteRequest = async () => {
            const result = await researchUI({
                function: ResearchUIFunction.APP_CHANGES,
                id: key.id,
                reqType: 'Delete',
            })
                .then((result) => {
                    if (result.success == 1) {
                        setTableData(newData);
                        setEditingKey('');
                        message.success('Successfully Deleted');
                    } else {
                        message.error('Not Possible to Delete this Request.');
                    }
                })
                .catch(() => message.error('Something Went Wrong.'));
        };
        deleteRequest();
    };

    const tableColumns = [
        {
            title: 'App Name',
            dataIndex: 'req_appName',
            width: '15%',
            editable: true,
            variable: 'appName',
            render: (text, record) => <Tooltip title={new Date(record.createdAt).toUTCString()}>{text}</Tooltip>,
        },
        {
            title: 'URL',
            dataIndex: 'req_url',
            width: '35%',
            editable: true,
            variable: 'url',
        },
        {
            title: 'Category',
            dataIndex: 'req_category',
            width: '30%',
            editable: true,
            variable: 'category',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: '15%',
            editable: false,
            variable: 'status',
            render: (text, record) => {
                return (
                    <>
                        {isEditing(record) ? (
                            <span>
                                <Typography.Link onClick={() => save(record)} style={{ marginRight: 8 }}>
                                    Save
                                </Typography.Link>
                                <Popconfirm title="Sure to cancel?" onConfirm={() => setEditingKey('')}>
                                    <a>Cancel</a>
                                </Popconfirm>
                            </span>
                        ) : (
                            <>
                                {text == 'Pending' ? (
                                    <Space direction={ANTD_SPACE.DIRECTION_HORIZONTAL}>
                                        {text + ' '}
                                        <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                                            Edit
                                        </Typography.Link>
                                        <Popconfirm
                                            title="Are you sure to delete this task?"
                                            onConfirm={() => deleteReq(record)}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Typography.Link disabled={editingKey !== ''} type="danger">
                                                Delete
                                            </Typography.Link>
                                        </Popconfirm>
                                    </Space>
                                ) : (
                                    text
                                )}
                            </>
                        )}
                    </>
                );
            },
        },
    ];

    const mergedColumns = tableColumns.map((col) => {
        if (!col.editable) return col;
        return {
            ...col,
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
                variable: col.variable,
            }),
        };
    });

    const EditableCell = ({ editing, dataIndex, title, record, index, children, variable, ...restProps }) => {
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item name={dataIndex} style={{ margin: 0 }} rules={fieldRules[variable]}>
                        {dataIndex == 'req_category' ? <Select {...catSelProp}></Select> : <Input size={SIZE.SMALL} placeholder={title} />}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    return (
        <>
            {loading ? (
                <Row justify={ANTD_COMMON_CSS.JUSTIFY_CENTER} gutter={24}>
                    <Col span={1}>
                        <Spin tip="Loading..."></Spin>
                    </Col>
                </Row>
            ) : (
                <>
                    <Row gutter={[16, 8]}>
                        <Col span={24}>
                            <Divider orientation={'left'} className={styles.dividerSmall}>
                                App Data
                            </Divider>
                        </Col>
                        <Col>
                            <Text>App Name: </Text>
                            <Text type={ANTD_TEXT.TYPE_SECONDARY} copyable>
                                {appName}
                            </Text>
                        </Col>
                        <Col>
                            <Text>URL: </Text>
                            <Text type={ANTD_TEXT.TYPE_SECONDARY} copyable>
                                {url}
                            </Text>
                        </Col>
                        <Col>
                            <Text>Category: </Text>
                            <Text type={ANTD_TEXT.TYPE_SECONDARY}>{category}</Text>
                        </Col>
                        <Col>
                            {priority == null ? (
                                ''
                            ) : (
                                <>
                                    <Text>Priority: </Text>
                                    <Text type={ANTD_TEXT.TYPE_SECONDARY}>{priority}</Text>
                                </>
                            )}
                        </Col>
                        <Col>
                            {connector == 'none' ? (
                                ''
                            ) : (
                                <>
                                    <Text>Connector: </Text>
                                    <Text type={ANTD_TEXT.TYPE_SECONDARY}>{connector}</Text>
                                </>
                            )}
                        </Col>
                    </Row>
                    {penReq ? (
                        ''
                    ) : (
                        <Form name="app_addition_form" form={subReqForm} initialValues={initVal} onFinish={onFinish} size={'small'}>
                            <Row style={{ marginTop: '5px' }}>
                                <Col span={24}>
                                    <Card
                                        title="New Changes"
                                        {...cardProp}
                                        extra={
                                            <UndoOutlined
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    subReqForm.resetFields(['edit_AppName', 'edit_URL', 'edit_Category']);
                                                }}
                                            />
                                        }
                                    >
                                        <Row gutter={2}>
                                            <Col span={8}>
                                                <Divider orientation={'left'} className={styles.dividerSmall}>
                                                    App Name
                                                </Divider>
                                                <Form.Item name="edit_AppName" rules={fieldRules.appName}>
                                                    <Input size={'small'} placeholder={'App Name'} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Divider orientation={'left'} className={styles.dividerSmall}>
                                                    URL
                                                </Divider>
                                                <Form.Item name="edit_URL" rules={fieldRules.url}>
                                                    <Input size={'small'} placeholder={'URL'} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Divider orientation={'left'} className={styles.dividerSmall}>
                                                    Category
                                                </Divider>
                                                <Form.Item name="edit_Category">
                                                    <Select {...catSelProp} disabled={categoryLocked}></Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Divider orientation={'left'} className={styles.dividerSmall}>
                                                    Comment
                                                </Divider>
                                                <Form.Item name="edit_comments">
                                                    <TextArea placeholder={'Comments'}></TextArea>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </Form>
                    )}
                    {appExistTableData.length > 0 ? (
                        <Row>
                            <Col span={24}>
                                <Badge.Ribbon text="Exist" color="red">
                                    <Card title="Already Exist Apps" size={SIZE.SMALL}>
                                        <Table
                                            bordered
                                            dataSource={appExistTableData}
                                            columns={[
                                                {
                                                    title: 'App ID',
                                                    dataIndex: 'application_id',
                                                    render: (text) => (
                                                        <a target={'_blank'} href={'/cciresearch/' + text}>
                                                            {text}
                                                        </a>
                                                    ),
                                                },
                                                {
                                                    title: 'Ref Table',
                                                    dataIndex: 'table',
                                                },
                                                {
                                                    title: 'Data',
                                                    dataIndex: 'data',
                                                },
                                            ]}
                                            pagination={false}
                                        ></Table>
                                    </Card>
                                </Badge.Ribbon>
                            </Col>
                        </Row>
                    ) : (
                        ''
                    )}
                    <Row style={{ marginTop: '5px' }}>
                        <Col span={24}>
                            <Card title="Changes Requested" {...cardProp}>
                                <Form form={tableForm} component={false}>
                                    <Table
                                        components={{
                                            body: { cell: EditableCell },
                                        }}
                                        bordered
                                        dataSource={tableData}
                                        columns={mergedColumns}
                                        rowClassName="editable-row"
                                        pagination={false}
                                    />
                                </Form>
                            </Card>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

export default ResearchUI;
